const lastModifiedLocaleKey = 'nnet-last-modified-locale';

export const getLastModifiedLocale = () =>
  localStorage.getItem(lastModifiedLocaleKey) || 'en';

export const setLastModifiedLocale = (locale: string) =>
  localStorage.setItem(lastModifiedLocaleKey, locale);
